// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ae6f9717","498":"1409966c","703":"27e00781","787":"39e1b783"}[chunkId] + ".chunk.js";
};